import { Controller } from '@hotwired/stimulus'

// Toggles one channel card between read and edit mode. Read mode shows the
// subscribed groups and component versions; Configure swaps both panes, for the
// change preview on the left and the group selectors on the right.
export default class extends Controller {
  static targets = ['readActions', 'editActions', 'versionsPane', 'formPane', 'chipsPane', 'previewPane']

  configure(event) {
    event.preventDefault()

    // A card with no rules and no versions renders collapsed; expand it so the
    // selectors are visible.
    this.element.classList.remove('release-channel-card--empty')
    this.element.classList.add('release-channel-card--editing')
    this.element.querySelector('.release-channel-card__body').hidden = false

    this.readActionsTarget.hidden = true
    this.editActionsTarget.hidden = false
    this.versionsPaneTarget.hidden = true
    this.formPaneTarget.hidden = false
    this.chipsPaneTarget.hidden = true
    // Unhiding the pane is what triggers the lazy preview frame to load.
    this.previewPaneTarget.hidden = false
  }

  cancel(event) {
    event.preventDefault()
    // Tagify keeps its own state, so re-render rather than trying to unwind it.
    window.location.reload()
  }
}
